import Box from 'app/components/base/Box'
import Container from 'app/components/base/Container'

interface BlogLayoutProps {
  withoutContainer?: boolean
}

const tag = 'section'

const BlogLayout: RFC<BlogLayoutProps> = ({
  children,
  withoutContainer = false
}) => {
  if (withoutContainer) {
    return <Box component={tag}>{children}</Box>
  }

  return (
    <Box component={tag}>
      <Container sx={{ pt: '40px', pb: '86px', maxWidth: { xs: '920px' } }}>
        {children}
      </Container>
    </Box>
  )
}

export default BlogLayout
